var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.renderText())}}),_vm._v(" "),_c('BaseButton',{attrs:{"tag":"button","label":_vm.show ? _vm.readLessLabel : _vm.readMoreLabel,"styles":"text-link","classes":"mt-xl"},on:{"click":_vm.toggleReadMore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }